import moment from 'moment';
import UserPlanTypes from 'constants/UserPlanTypes';

/**
 * Get scheduled weekly check dates (Sundays) for top 100 checks
 * Agency/Custom users don't need weekly dots since they have daily top 100 checks
 * @param {string} userPlanType - The user's plan type
 * @returns {string[]} Array of date strings in YYYY-MM-DD format
 */
export const getScheduledWeeklyDates = (userPlanType) => {
    // Agency/Custom users get daily top 100 checks, so no separate weekly dots needed
    if (userPlanType === UserPlanTypes.AGENCY || userPlanType === UserPlanTypes.CUSTOM) {
        return [];
    }

    const dates = [];
    const today = moment().startOf('day');

    for (let i = 0; i < 10; i += 1) {
        // Get next Sunday (day 0)
        const sunday = moment().add(i, 'weeks').day(0);

        if (sunday.isAfter(today)) {
            dates.push(sunday.format('YYYY-MM-DD'));
        }
    }

    return dates;
};

/**
 * Get scheduled daily check dates for top 100 checks
 * Only for Agency/Custom users
 * @param {string} userPlanType - The user's plan type
 * @returns {string[]} Array of date strings in YYYY-MM-DD format
 */
export const getScheduledDailyDates = (userPlanType) => {
    if (userPlanType !== UserPlanTypes.AGENCY && userPlanType !== UserPlanTypes.CUSTOM) {
        return [];
    }

    const dates = [];
    const today = moment().startOf('day');

    for (let i = 1; i <= 65; i += 1) {
        dates.push(today.clone().add(i, 'days').format('YYYY-MM-DD'));
    }

    return dates;
};

/**
 * Check if user has daily tracking based on their plan type
 * @param {string} userPlanType - The user's plan type
 * @returns {boolean}
 */
export const hasDailyTracking = (userPlanType) => {
    return userPlanType === UserPlanTypes.AGENCY || userPlanType === UserPlanTypes.CUSTOM;
};
